import Yup from 'utils/extended-yup'
import ProductAttributeService from 'domains/product-attribute/services'


/**
 * default schema for Seller Inbound Curate Accept Product form.
 */
const defaultSchema = () => {

  let defaultSchema = {
    category  : Yup.string().required('Required'),
    condition : Yup.string().required('Required'),
    brand     : Yup.string().required('Required'),
    price     : Yup.string().required('Required')
  }

  return Yup.object().shape({ ...defaultSchema })
}

/**
 * Generate dynamic schema
 * @param {array} attributes - Product Attribute
 */
const dynamicSchema = ({ attributes }) => {
  const attributesSchema = Yup.object().shape({
    ...ProductAttributeService.buildFormikDatatypeValidationSchmea(attributes)
  })

  // merge with default schema
  const schema = attributesSchema.concat(defaultSchema())
  return schema
}

export {
  defaultSchema,
  dynamicSchema
}
